<template>

    <div class="page-static-container">

        <header-static v-if="!isNativeUser"></header-static>

        <article :class="{ 'privacy-container': token }"
                 class="page-static-text-container"
                 v-html="html"></article>

        <article v-if="token" class="page-static-text-container gdpr-container">

            <section class="cfsp-section">

                <h3 class="cfsp-title-3 cfsp-text-blue">{{ $t('privacy_title') }}</h3>

                <p class="cfsp-text">{{ $t('privacy_text_1') }}</p>

                <a class="cfsp-text link" @click="getGDPR">{{ $t('privacy_link_data') }} {{ $t('privacy_web_only') }}</a>

                <p class="cfsp-text">{{ $t('privacy_text_2') }}</p>

            </section>


            <toast ref="toast"></toast>

        </article>

        <footer-landing v-if="!isNativeUser"></footer-landing>

        <link href="/static/css/style.css" rel="stylesheet" type="text/css">

    </div>

</template>

<script>

import Vuex from 'vuex'

import Api from '@/api'

import Storage from '@/helpers/storage'

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import HeaderStatic from '@/components/headers/HeaderStatic'
import FooterLanding from '@/components/FooterLanding'
import Toast from '@/components/Toast'

export default {

    name: 'privacy',

    components: {HeaderStatic, FooterLanding, Toast},


    watch: {

        lang: function () {
            this.loadContent()
        }

    },

    computed: {

        ...Vuex.mapGetters(['lang']),

        token: function () {
            return Storage.getItem('token')
        },

        isNativeUser: function () {
            return this.$route.path.indexOf('/native/') > -1
        }
    },

    data() {
        return {
            html: ''
        }
    },

    created() {
        UserFlow.setPage(this, 'privacy')
    },

    mounted() {

        this.loadContent()

    },

    methods: {

        getGDPR() {

            Tag.clickAmplitude(this, 'download_gdpr')

            Api.user
                .getGDPR()
                .then(result => {

                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(new Blob([result], {type: 'text/plain'}))
                    link.download = 'cleanfox-data-portability.txt'
                    link.click()

                })
                .catch(() => {
                    this.$refs.toast.open()
                })
        },

        loadContent() {

            this.$http.get(`/static/privacy/${I18n.get(this)}.html`)
                .then(response => {
                    this.html = response.data
                })
        }

    }
}
</script>

<style lang="scss" scoped>

.gdpr-container {
    padding: 0 16px 112px;
}

.link {
    color: $blue;
    display: block;
    margin: 16px 0 32px;
}

.privacy-container {
    background-image: none;
    padding-bottom: 0;
}

</style>
